import { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Tooltip,
    Modal,
    CircularProgress,
    Typography
} from "@mui/material";
import { Texto, buttonGuardar, Input,  modalStyle, buttonCancelar} from "../../Layouts/CustomStyles";
import { DataGrid } from "@mui/x-data-grid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { DiseñoDataGrid } from "../FuncionesGenerales/DataGrid";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useIngresoTodosINMOB } from "../../Hook/Inmobiliaria/Ingresos";
import { Loading } from "../../Utils/Loading";
import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";

export const CategoriaIngresoINMOB = () => {
    const {
        IngresosCategoriaInmob,
        loadingIngresosCategoriaInmob,
        refetchIngresoCategoriaINMOB: fetchIngresoCategoriaINMOB
    } =useIngresoTodosINMOB();
    const{ crearCategoriaingresos,
    editarCategoriaingresos,
    eliminarCategoriaingresos} = useIngresoINMOB();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [categoriaAEliminar, setCategoriaAEliminar] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [nombreCategoria, setNombreCategoria] = useState("");
    const [editando, setEditando] = useState(null);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const rowsData = IngresosCategoriaInmob ?? [];
    // 🔹 ABRIR CREAR
    const handleCrear = () => {
        setEditando(null);
        setNombreCategoria("");
        setOpenDialog(true);
    };

    // 🔹 ABRIR EDITAR
    const handleEditar = (row) => {
        setEditando(row);
        setNombreCategoria(row.nombre);
        setOpenDialog(true);
    };

    // 🔹 GUARDAR (crear o editar)
   const handleGuardar = async () => {
    if (!nombreCategoria.trim()) return;

    try {
        setEnviandoAlert(true);

        if (editando) {
            await editarCategoriaingresos(editando.id, {
                nombre: nombreCategoria
            });

            setAlertMessage("Categoría actualizada");
        } else {
            await crearCategoriaingresos({
                nombre: nombreCategoria
            });

            setAlertMessage("Categoría creada");
        }

        setSuccessAlertOpen(true);
        await fetchIngresoCategoriaINMOB();

        setOpenDialog(false);
        setNombreCategoria("");
        setEditando(null);

    } catch (error) {
        setErrorAlertOpen(true);
        setAlertMessage("Error en la operación");
    } finally {
        setEnviandoAlert(false);
    }
};
const handleEliminar = (row) => {
    setCategoriaAEliminar(row);
    setOpenDeleteModal(true);
};
    // 🔹 ELIMINAR
   const confirmarEliminar = async () => {
    try {
        setEnviandoAlert(true);

        await eliminarCategoriaingresos(categoriaAEliminar.id);

        setAlertMessage("Categoría eliminada correctamente");
        setSuccessAlertOpen(true);

       await fetchIngresoCategoriaINMOB();
    } catch (error) {
        setErrorAlertOpen(true);
        setAlertMessage("Error al eliminar categoría");
    } finally {
        setEnviandoAlert(false);
        setOpenDeleteModal(false);
        setCategoriaAEliminar(null);
    }
};

    // 🔹 COLUMNAS
    const columns = [
        { field: "id", headerName: "ID", width: 90 },
        { field: "nombre", headerName: "Categoría", flex: 1 },

        {
            field: "acciones",
            headerName: "Acciones",
            width: 150,
            renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        width: 150,
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <button className="edit-button" onClick={() => handleEditar(params.row)}>
                                        <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                            <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                                        </svg>
                                    </button>
                                    <button className="delete-button" onClick={() => handleEliminar(params.row)}>
                                        <FaTrashCan className="delete-svgIcon" />
                                    </button>
                                </Box>
                            );
                        },

        }
    ];

    if (loadingIngresosCategoriaInmob) {
    return <Loading />;
}
    return (
        <Box>

            {/* HEADER */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              

               
                  <Tooltip title="Crear categoria">
                                        <IconButton
                                             onClick={handleCrear}
                                            sx={{
                                                backgroundColor: "#fff3e0",
                                                width: 50,
                                                height: 50,
                                                "&:hover": { backgroundColor: "#ffe0b2" }
                                            }}
                                        >
                                            <AddCircleIcon />
                                        </IconButton>
                                    </Tooltip>
            </Box>

            {/* DATAGRID */}
            <Box sx={{ height: 400, width: "100%" }}>
                <DataGrid
                   rows={rowsData}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10]}
                     slots={{ noRowsOverlay: DiseñoDataGrid }}
                                                    getRowId={(row) => row.id}
                                                    sx={{
                                                        fontFamily: 'Poppins, sans-serif',
                                                        '& .MuiDataGrid-columnHeaders': {
                                                            color: '#113e21ff',
                                                            fontWeight: 600,
                                                            textTransform: 'capitalize',
                                                        },
                                                        '& .MuiDataGrid-cell': {
                                                            textTransform: 'capitalize',
                                                        },
                                                    }}
                />
            </Box>

            {/* DIALOG */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle sx={Texto}>
                    {editando ? "Editar categoría" : "Nueva categoría"}
                </DialogTitle>

                <DialogContent>
                    <TextField
                        label="Nombre categoría"
                        fullWidth
                        value={nombreCategoria}
                        onChange={(e) => setNombreCategoria(e.target.value)}
                        sx={{...Input, mt: 2 }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} sx={buttonCancelar}>
                        Cancelar
                    </Button>
                    <Button  onClick={handleGuardar} sx={buttonGuardar}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
    open={openDeleteModal}
    onClose={() => setOpenDeleteModal(false)}
>
    <DialogTitle sx={Texto}>
        Confirmar eliminación
    </DialogTitle>

    <DialogContent>
        <Typography>
            ¿Estás seguro que deseas eliminar la categoría{" "}
            <strong>{categoriaAEliminar?.nombre}</strong>?
        </Typography>
    </DialogContent>

    <DialogActions>
        <Button
            onClick={() => setOpenDeleteModal(false)}
            sx={buttonCancelar}
        >
            Cancelar
        </Button>

        <Button
            onClick={confirmarEliminar}
            sx={buttonGuardar}
            color="error"
        >
            Eliminar
        </Button>
    </DialogActions>
</Dialog>
                <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={enviandoAlert}>
                            <Box sx={modalStyle}>
                                <section style={{ textAlign: "center", padding: "1rem" }}>
                                    <CircularProgress style={{ color: "#2a8d74" }} />
                                    <p className="alert-text">Procesando solicitud...</p>
                                </section>
                            </Box>
                        </Modal>
        </Box>
    );
};